// extracted by mini-css-extract-plugin
export default {"container":"Snippet_container__80YVW","info":"Snippet_info__I+8TW","date":"Snippet_date__wLzyX","blurb":"Snippet_blurb__1sjEo"};